import React from 'react';
import BecomeArtistForm from '../../../components/organism/BecomeArtistForm/BecomeArtistForm';

function BecomeArtist() {
  return (
    <div>
      <BecomeArtistForm />
    </div>
  );
}

export default BecomeArtist;
